import { NoddiAsyncError } from 'noddi-types';
import { errorCodesEnglish } from './error';

export const mapErrorCodeToUiMessage = ({
  error,
  errorCodes
}: {
  error: NoddiAsyncError | (NoddiAsyncError | null)[];
  errorCodes?: Record<string, string> & { genericErrorMessage: string };
}) => {
  const errorToRender = Array.isArray(error) ? error.find((e) => e !== null) : error;

  const errors = errorToRender?.response?.data.errors ?? [];

  const errorCodeTexts = errorCodes ?? errorCodesEnglish;

  if (errors.length === 1) {
    const code = errors[0]?.code;

    return errorCodeTexts[code as keyof typeof errorCodeTexts] ?? errorCodeTexts.genericErrorMessage;
  }

  if (errors.length > 1) {
    // reducer that iterates through errors and returns a string
    const message = errors.reduce((prev, curr, index) => {
      const code = curr?.code ?? '';

      const errorCode = errorCodeTexts[code as keyof typeof errorCodeTexts] ?? errorCodeTexts.genericErrorMessage;

      // don't apply error code if errorCodeTexts.genericErrorMessage is already in string
      // also strip away any trailing commas
      if (errorCode === errorCodeTexts.genericErrorMessage && prev.includes(errorCodeTexts.genericErrorMessage)) {
        const cleanedPrev = prev.replace(/(,\s*)+$/, '');
        return cleanedPrev;
      }

      if (index === errors.length - 1) {
        prev += errorCode;
      } else if (errorCode) {
        prev += `${errorCode}, `;
      }

      return prev;
    }, '');
    return message;
  }

  return errorCodeTexts.genericErrorMessage;
};
